import { IS_BROWSER } from "@config/consts";

export const isSafari =
  IS_BROWSER &&
  /Safari/.test(navigator.userAgent) &&
  /Apple Computer/.test(navigator.vendor);
